import api from './axios';

/**
 * Billing + the verification queue (spec §8.1).
 *
 * `submitProof` sends multipart — do NOT set Content-Type by hand; the browser
 * has to add the multipart boundary itself.
 */
export const listBilling = (params = {}) => api.get('/v1/billing', { params });

export const submitProof = (billId, { file, paymentChannel, paymentReference, paymentNotes }) => {
  const form = new FormData();
  form.append('proof', file);
  form.append('payment_channel', paymentChannel);
  form.append('payment_reference', paymentReference);
  if (paymentNotes) form.append('payment_notes', paymentNotes);

  return api.post(`/v1/billing/${billId}/submit-proof`, form);
};

/** decision: 'verify' | 'return' (a return needs return_reason). */
export const decideBill = (billId, payload) => api.post(`/v1/billing/${billId}/verify`, payload);

/**
 * Issues a statement by hand. The amount is NOT sent — the server derives it
 * from the fee type, so this cannot bill a member the wrong figure.
 */
export const issueBill = (payload) => api.post('/v1/billing', payload, {
  headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
});

/**
 * Settles a statement paid at the counter. Runs the same transitions the online
 * path runs, so the member activates and their uplines are credited identically.
 */
export const recordCounterPayment = (billId, payload) => api.post(`/v1/billing/${billId}/counter-payment`, payload, {
  headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
});

/**
 * A short-lived link to the proof image. Minted per request and expiring in
 * minutes — it is a bearer credential for a financial record, so it is fetched
 * when the admin opens the receipt, never cached alongside the row.
 */
export const getBillProof = (billId) => api.get(`/v1/billing/${billId}/proof`);

export const createBillingExport = (filters = {}) => api.post('/v1/billing-exports', filters, {
  headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
});

export const getBillingExport = (exportId) => api.get(`/v1/billing-exports/${exportId}`);
